import { render, staticRenderFns } from "./secondTable.vue?vue&type=template&id=17465fd8&scoped=true"
import script from "./secondTable.vue?vue&type=script&lang=js"
export * from "./secondTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17465fd8",
  null
  
)

export default component.exports